import { http } from '@/http/axios.js'
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'
import { dateFormat } from '@/utils/index.js'

// 资商通订单 - 分页列表
export function getZstOrderListAPI(params) {
  return http({
    url: '/admin/alipay/zst/order/page',
    method: 'get',
    params
  })
}

// 资商通订单 - 详情（分账明细）
export function getZstOrderDetailAPI(params) {
  return http({
    url: '/admin/alipay/zst/order/detail',
    method: 'get',
    params
  })
}

export function buybackZstOrderAPI(data) {
    return http({
        url: "/admin/alipay/zst/order/buyback",
        method: "post",
        data,
    });
}

// 资商通订单 - 导出
export function exportZstOrderAPI(data) {
  showScreenLoading()
  axios({
    method: 'post',
    url: '/api/admin/alipay/zst/order/export',
    responseType: 'blob',
    data,
    headers: {
      Authorization: getToken() || ''
    }
  })
    .then(async res => {
      hideScreenLoading()
      let data = res.data
      let url = window.URL.createObjectURL(new Blob([data]))
      let a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      let filename = `资商通订单列表${dateFormat()}.xlsx`
      a.setAttribute('download', decodeURIComponent(filename))
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
    })
    .catch(error => {
      hideScreenLoading()
      console.log(error)
    })
}
